import ja from './ja'

export default {
  ja
}
